/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable camelcase */
import { validators } from '../../utils/validators';

const validate = (values, props) => {
    const { REQUIRED, MAX_LENGTH } = validators;
    const errors = {};

    const credentialsErrors = [];

    if (
        values.credentials &&
        values.credentials.length &&
        values.credentials.length > 0
    ) {
        values.credentials.forEach((credential, credentialIndex) => {
            const credentialError = {};

            if (!credential || REQUIRED(credential.merchantPGCode)) {
                credentialError.merchantPGCode = 'Please enter Merchant Id';
            }

            if (credentialIndex > 0) {
                if (!credential || REQUIRED(credential.paymentType)) {
                    credentialError.paymentType = 'Please select Payment Mode';
                }
                if (!credential || REQUIRED(credential.subMode)) {
                    credentialError.subMode = 'Please select Sub Mode';
                }
            }

            if (!credential || REQUIRED(credential.accessCode)) {
                credentialError.accessCode = 'Please enter Access Code';
            }
            if (!credential || REQUIRED(credential.secret)) {
                credentialError.secret = 'Please enter Secure Secret';
            }

            if (!credential || REQUIRED(credential.username)) {
                credentialError.username = 'Please enter AMA Username';
            }
            if (!credential || REQUIRED(credential.password)) {
                credentialError.password = 'Please enter AMA Password';
            }
            if (!credential || REQUIRED(credential.merchantPGKey)) {
                credentialError.merchantPGKey = 'Please enter Salt';
            }
            if (!credential || REQUIRED(credential.merchantKey)) {
                credentialError.merchantKey = 'Please enter Merchant Key';
            }
            if (!credential || REQUIRED(credential.merchantPGSecurityKey)) {
                credentialError.merchantPGSecurityKey =
                    'Please enter Shared Secret Key';
            }
            if (
                !credential ||
                MAX_LENGTH(credential.merchantPGSecurityKey, 100)
            ) {
                credentialError.merchantPGSecurityKey =
                    'Max number character allowed is 100';
            }
            if (!credential || REQUIRED(credential.keySerialNumber)) {
                credentialError.keySerialNumber =
                    'Please enter Key Serial Number';
            }
            if (!credential || MAX_LENGTH(credential.keySerialNumber, 50)) {
                credentialError.keySerialNumber =
                    'Max number character allowed is 50';
            }

            if (Object.keys(credentialError).length) {
                credentialsErrors[credentialIndex] = credentialError;
            }
        });

        if (
            values.credentials &&
            values.credentials.length &&
            values.credentials.length > 1 &&
            !values.credentials[0]?.status?.includes('ENABLED') &&
            values.credentials?.some(cred => cred?.status?.includes('ENABLED'))
        ) {
            credentialsErrors[0].status =
                'Please disable all sub mode configurations before disabling Default.';
        }

        if (
            values.credentials &&
            values.credentials.length &&
            values.credentials.length > 1
        ) {
            // Create an object to keep track of unique combinations
            const uniqueCombinations = {};
            // Iterate through the credentials
            for (let i = 0; i < values.credentials.length; i++) {
                const credential = values.credentials[i];
                const paymentType = credential?.paymentType;
                const subMode = credential?.subMode;
                const combination = `${paymentType}-${subMode}`;
                // Check if the combination already exists in uniqueCombinations

                if (uniqueCombinations[combination]) {
                    // This combination is a duplicate
                    // Add an error to the current credential
                    credentialsErrors[i].paymentType =
                        'Duplicate configuration for payment type and sub mode. Please check again.';
                    credentialsErrors[i].subMode =
                        'Duplicate configuration for payment type and sub mode. Please check again.';
                } else {
                    // Store the combination in uniqueCombinations
                    uniqueCombinations[combination] = true;
                }
            }
        }

        if (credentialsErrors.length) {
            errors.credentials = credentialsErrors;
        }
    }

    const { initialValues } = props;

    if (
        initialValues.test_merchantId ||
        initialValues.test_salt ||
        values.test_merchantId ||
        values.test_salt
    ) {
        if (REQUIRED(values.test_merchantId)) {
            errors.test_merchantId = 'Please enter Merchant Id';
        }

        if (REQUIRED(values.test_salt)) {
            errors.test_salt = 'Please enter Salt';
        }
    }

    if (
        initialValues.test_merchantId ||
        initialValues.test_secret ||
        initialValues.test_accessCode ||
        initialValues.test_amaUsername ||
        initialValues.test_amaPassword ||
        values.test_referenceId ||
        values.test_merchantId ||
        values.test_secret ||
        values.test_accessCode ||
        values.test_amaUsername ||
        values.test_amaPassword
    ) {
        if (REQUIRED(values.test_merchantId)) {
            errors.test_merchantId = 'Please enter Merchant Id';
        }

        if (REQUIRED(values.test_secret)) {
            errors.test_secret = 'Please enter Secure Secret';
        }

        if (REQUIRED(values.test_accessCode)) {
            errors.test_accessCode = 'Please enter Access Code';
        }

        if (REQUIRED(values.test_amaUsername)) {
            errors.test_amaUsername = 'Please enter AMA Username';
        }

        if (REQUIRED(values.test_amaPassword)) {
            errors.test_amaPassword = 'Please enter AMA Password';
        }
    }

    if (
        initialValues.test_merchantId ||
        initialValues.test_secret ||
        initialValues.test_accessCode ||
        values.test_merchantId ||
        values.test_secret ||
        values.test_accessCode
    ) {
        if (REQUIRED(values.test_merchantId)) {
            errors.test_merchantId = 'Please enter Merchant Id';
        }

        if (REQUIRED(values.test_secret)) {
            errors.test_secret = 'Please enter Secure Secret';
        }

        if (REQUIRED(values.test_accessCode)) {
            errors.test_accessCode = 'Please enter Access Code';
        }
    }

    if (
        initialValues.test_referenceId ||
        initialValues.test_merchantId ||
        initialValues.test_accountPassword ||
        initialValues.test_username ||
        initialValues.test_soapKey ||
        initialValues.test_sharedSecretKey ||
        initialValues.test_keySerialNumber ||
        values.test_referenceId ||
        values.test_merchantId ||
        values.test_accountPassword ||
        values.test_username ||
        values.test_soapKey ||
        values.test_sharedSecretKey ||
        values.test_keySerialNumber
    ) {
        if (REQUIRED(values.test_merchantId)) {
            errors.test_merchantId = 'Please enter Merchant Id';
        }
        if (REQUIRED(values.test_sharedSecretKey)) {
            errors.test_sharedSecretKey = 'Please enter Shared Secret Key';
        }
        if (MAX_LENGTH(values.test_sharedSecretKey, 100)) {
            errors.test_sharedSecretKey = 'Max number character allowed is 100';
        }
        if (REQUIRED(values.test_keySerialNumber)) {
            errors.test_keySerialNumber = 'Please enter Key Serial Number';
        }
        if (MAX_LENGTH(values.test_keySerialNumber, 50)) {
            errors.test_keySerialNumber = 'Max number character allowed is 50';
        }
    }

    return errors;
};

export default validate;
